import * as Sentry from '@sentry/react';

// Same rule as the management portal: a unixi.io admin is not recorded, and
// login-as does not change their email. See unixi-management-portal
// src/Utils/sentryIdentity.js.
let replayExcluded = false;

const REPLAY_SESSION_KEY = 'sentryReplaySession';

export function isUnixiStaffEmail(email) {
    if (typeof email !== 'string') {
        return false;
    }
    const at = email.lastIndexOf('@');
    if (at < 1) {
        return false;
    }
    const domain = email.slice(at + 1).trim().toLowerCase();
    return domain === 'unixi.io' || domain.endsWith('.unixi.io');
}

export function replayIsExcluded() {
    return replayExcluded;
}

function clearStickyReplay() {
    try {
        window.sessionStorage.removeItem(REPLAY_SESSION_KEY);
    } catch (e) {
        // sessionStorage can throw when storage is blocked.
    }
}

function discardActiveReplay() {
    const replay = Sentry.getClient()?.getIntegrationByName?.('Replay');
    const container = replay && replay._replay;
    if (container && typeof container.stop === 'function') {
        // Replay.stop() uploads when the session was sampled. Discard it.
        container.stop({ forceFlush: false });
        return;
    }
    clearStickyReplay();
}

export function excludeReplayForUnixiStaff(user) {
    if (!isUnixiStaffEmail(user?.email)) {
        return false;
    }
    replayExcluded = true;
    discardActiveReplay();
    return true;
}

export function replaySampleRates() {
    let email = '';
    try {
        const raw = window.sessionStorage.getItem('user');
        email = raw ? JSON.parse(raw)?.email : '';
    } catch (e) {
        email = '';
    }
    if (isUnixiStaffEmail(email)) {
        replayExcluded = true;
        clearStickyReplay();
        return { replaysSessionSampleRate: 0, replaysOnErrorSampleRate: 0 };
    }
    return { replaysSessionSampleRate: 0.1, replaysOnErrorSampleRate: 1.0 };
}
